import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import WhseJob0301Actions, { WhseJob0301Types } from '../Stores/WhseJob0301/Actions';

const getAppStore = state => state.app;

export function* whseJob0301FetchWhseJob0301({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(WhseJob0301Actions.whseJob0301FetchWhseJob0301Loading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `whseJob/indexProcess/WHSE_JOB_03_01/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        WhseJob0301Actions.whseJob0301FetchWhseJob0301Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(WhseJob0301Actions.whseJob0301FetchWhseJob0301Loading(false));
  }
}

export function* whseJob0301CreateWhseJob0301({ hdrIds, toStorageBinId }) {
  try {
    yield put(WhseJob0301Actions.whseJob0301CreateWhseJob0301Loading(true));

    const app = yield select(getAppStore);

    const postData = {
      hdrIds,
      toStorageBinId
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `whseJob/createProcess/WHSE_JOB_03_01`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(WhseJob0301Actions.whseJob0301CreateWhseJob0301Success(result.data));

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(WhseJob0301Actions.whseJob0301CreateWhseJob0301Loading(false));
  }
}

export function* whseJob0301GoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/pickListDetail/update/${hdrId}`));
}

export const saga = [
  takeLatest(WhseJob0301Types.WHSE_JOB0301_GO_TO_DOCUMENT, whseJob0301GoToDocument),
  takeLatest(WhseJob0301Types.WHSE_JOB0301_FETCH_WHSE_JOB0301, whseJob0301FetchWhseJob0301),
  takeLatest(WhseJob0301Types.WHSE_JOB0301_CREATE_WHSE_JOB0301, whseJob0301CreateWhseJob0301)
];
